<template> 
  <div>
    <b-toast
		id="toast-check-modal-calendar-class"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-check.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
		<b-toast
		id="toast-equis-modal-calendar-class"
		variant="none"
		no-close-button
		toaster="b-toaster-top-center"
		>
		<img
			src="@/assets/img/ico-equis.png"
			style="margin-right: 10px; margin-top: -2px"
		/>
		{{ message }}
		</b-toast>
    
    <b-breadcrumb>
      <b-breadcrumb-item active>{{$t('horario.breadcrumb.titulo')}}</b-breadcrumb-item>
    </b-breadcrumb>

    <div class="card" style="padding: 3rem;">
        <div v-if="showLoadingFirst" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
        </div>
        <div v-else>
          <div>
            <b-row>
                <b-col style="display:flex;">     
                <div class="card card-next-class">
                  <div class="left">
                    <img src="@/assets/img/girdRequest.png" class="mr-3">
                    <div v-if="nextDateClass" class="time mr-2">
                      <h6>{{$t('horario.next-class.nextClass')}}</h6>
                      <span style="font-size:14px">{{nextDateClass}}</span>
                      <span style="font-size:14px">{{nextClass}}</span>
                    </div>
                    <div v-else>
                      <p>{{$t('reusables.no-class-schedule')}}</p>
                    </div>
                  </div>
                  <button v-if="nextDateClass" type="button" class="btn btn-primary" :class="nextClassLink != null? '': 'disabled'"  @click="openLinkClassLocal(nextClassLink)">
                    <icon name="video" />{{$t('horario.next-class.button-pass')}}
                  </button>
                </div>
                </b-col>
                <b-col>
                <div class="card card_teacher list" style="padding:20px">
                    <div class="d-flex">
                        <div class="perfil">
                            <b-avatar
                            variant="light"
                            :src="dataTeacher.photo ? dataTeacher.photo : urlPhoto "
                            size="4.5rem"
                            ></b-avatar>
                            <b-form-rating :value="dataTeacher.totalQualification" readonly no-border></b-form-rating>
                          <b-link @click="getTeacherInformationAndComments(dataTeacher.id)" >{{dataTeacher.totalCommentary}} {{$t('horario.next-class.link')}}</b-link>
                        </div>
                      <div class="info">
                          <h6>{{dataTeacher.strFullName}}</h6>
                          <p>
                          <icon name="location" />{{dataTeacher.location}}
                          </p>
                      </div>
                    </div>
                </div>
                </b-col>
            </b-row>
        
            
          </div>
          <div class="calendar">
          <div class="body-header pt-4">
            <div class="content-buttons" style="display: flex;justify-content: flex-end;" v-if="isRepresentative">
              <b-button variant="outline-primary"  v-if="showEditSchedule"  @click="modalSchedule"  class="btn-outline mr-4 "><icon name="calendar" />{{$t('horario.next-class.see-edition')}}</b-button>
              <b-button variant="outline-primary" @click="showModalEditarHorario" :disabled="disabledButton" v-if="!showEditSchedule && flagEdit" class="btn-outline mr-4"><icon name="edit-pencil" />{{$t('horario.next-class.save-changes')}}</b-button>
              <b-button variant="outline-primary" v-if="!showEditSchedule && !flagEdit" @click="editCalendar" v-show="!hideButtonsForEdit" class="mr-4" :style="'position: relative;bottom: '+`${flagShowHeader ? '-38px' : 0}`+' ;z-index:10'"><icon name="edit-pencil" />{{$t('horario.next-class.edit-schedule')}}</b-button>
            	<b-button variant="danger" class="mr-4" @click="reply" v-if="!showEditSchedule && flagEdit" ><icon name="undo" />{{$t('horario.reply.text')}}</b-button>
              <b-button variant="primary" v-if="!showEditSchedule && !flagEdit && !flagPlanTest" @click="getTeacherChanges" v-show="!hideButtonsForEdit" :style="'position: relative;bottom: '+`${flagShowHeader ? '-38px' : 0}`+';z-index:10'">{{$t('horario.next-class.changue-teacher')}}</b-button>
            </div>
          </div>
          </div>
          <b-alert
              :show="dismissCountDown"
              dismissible
              variant="warning"
              @dismissed="dismissCountDown = 0"
              @dismiss-count-down="countDownChanged"
            >
              {{$t('horario.calendario.text.6')}} {{ dismissCountDown }}
          </b-alert>
          <!-- 
             :min ="minDate"
                    :max ="maxDate"
                    :disabled="!disabledDate"
            <div v-if="showLoading" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>-->
          <div v-if="showLoadingCalendar" class="container-loading">
            <b-spinner :label="$t('reusables.loading')" ></b-spinner>
          </div>
          <div v-else class="container-calendar" style="position:relative;">
            <div class="body-header edit" v-show="!hideButtonsForEdit" style="position: absolute;left: 200px;width: 150px;top: 3px" v-if="getShowSelect">
              <CustomSelect 
                @input="idValueSelectEventSelectedTime" 
                :options="optionsTime"
                value="value"
                label="text" 
                :default="null"
                :defaultValue="this.selectedTime"
                :isActiveMethodValidOpcion="true"
                @change="getWeek()"
              />
                <!-- <b-form-select class="custom-select" v-model="selectedTime" :options="optionsTime" @change="getWeek"></b-form-select> -->
            </div> 
        
          <FullCalendar  class="demo-app-calendar" :options="calendarOptions" :custom-buttons="calendarOptions.customButtons" ref="fullCalendarStudent" >
         
            <!-- display-header para que desaparezca las opciones-->
          
            <template v-slot:eventContent="arg" >
              <div class="fc-event-main-frame" @click="getDataClass(arg.event)">
                <span v-show="arg.event.startEditable" style="font-size: 1.1rem;" @click.stop.prevent="removeEvent(arg.event)"><icon name="close-2" /></span>
                <!-- <span v-show="arg.event.startEditable" style="font-size: 1.1rem;"  @click.stop.prevent="removeEvent(arg.event)" class="material-icons-outlined">delete</span> -->
                <span v-show="!flagEdit && arg.event.extendedProps.linkClass == null && !arrStatusNotEditableLinkClass.includes(arg.event.extendedProps.stateClass)" class="material-icons" style="color: red;">priority_high</span>
                
                <div class="fc-event-time">{{ arg.timeText }}</div>
                <div class="fc-event-title-container">
                  {{ arg.event.title }}
                </div>
              </div>
            </template>
          </FullCalendar>
          </div>
         
        </div>
       
        	<div>
            <b-modal id="modal-save-change"  :centered="true">
              <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
                <h5 style="text-align: center;">{{$t('class-calendar.text.3')}} {{dataTeacher.strFullName}} ?</h5>	
              </template>
              <div class="content-calendar mt-3" v-if="!this.flagPlanTest" >
                  <p>{{$t('horario.next-class.fecha')}}
                  <div>
                      <b-form-datepicker
                      :locale="lang"
                      :hide-header="true"
                      v-model="SelectBeginningDate"
                      
                      :value-as-date="true"
                      
                      :min ="minDate"
                      :max ="maxDate"
                      :disabled="disabledButton"
                      :start-weekday="1"
                      required
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      v-bind:class="{ error: $v.SelectBeginningDate.$error}"
                      :placeholder="formatDate"
                    ></b-form-datepicker>
                    <div class="error-input">{{ validationForm($v.SelectBeginningDate)}}</div>
                  </div>
                                   
              </div>
              <template #modal-footer>
                <b-button variant="danger" @click="$bvModal.hide('modal-save-change')">{{$t('modals.cancel-request.button-cancel')}}</b-button>
                <b-button @click="saveChange" variant="primary" :disabled="enableDate">
                  <template v-if="!showSpinnerSend">{{$t('class-calendar.button.1')}} </template>
                  <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="light"
                    label="Spinning"
                  ></b-spinner>
                </b-button>
              </template>
            </b-modal>
          </div>
       
          
          <b-modal
            id="modal-add-event"
            centered
          
            :title="$t('title.11')"
            @close="closeModal"
          >
            <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
              <h5>{{$t('title.11')}}</h5>
            </template>
            <p class="d-flex align-items-center" v-if="flagPlanTest">
              <i class="material-icons-outlined mr-3">bookmark</i>
              <span>{{ $t('reusables.test-class') }}</span>
            </p>
             <p class="d-flex align-items-center" v-else>
              <i class="material-icons-outlined mr-3">class</i>
              <span style="white-space: pre-line;">{{ titleCourse }}</span>
            </p>
         
            <p class="d-flex align-items-center" >
              <span class="material-icons-outlined mr-3">schedule</span>
              <span>{{
                this.eventCreated != null
                  ? getFormatDate(this.eventCreated.startStr,this.eventCreated.endStr, this.lang,flagPlanTest,maximoHorasCalendario )
                  : ""
              }}</span>
            </p>
            <div>
              <b-alert
                show
                variant="danger"
                style="padding: 5px; font-size: 0.7rem; text-align: center"
                v-if="showAlertModal"
                >{{ message }}</b-alert
              >
            </div>
              <template #modal-footer>
                <b-button variant="danger" @click="closeModal"> {{$t('horario.buttons.cancel')}} </b-button>
                <b-button @click="saveEvent" variant="primary">
                  <template v-if="!showSpinnerSaveSchedule">{{$t('horario.buttons.save')}}</template>
                  <b-spinner
                    style="width: 1rem !important; height: 1rem !important"
                    v-else
                    variant="success"
                    label="Spinning"
                  ></b-spinner>
                </b-button>
            </template>
  
          </b-modal>
          <!--MODAL CON INFORMACION DE LA CLASE-->
          <b-modal id="modal-class-info" centered @close="closeModalRemove" :hide-footer="!(infoClass.stateClass && !arrStatusNotEditableLinkClass.includes(infoClass.stateClass))">
            <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
              <h5>{{$t('horario.modal-notes.text-4')}}</h5>
            </template>
            <p class="d-flex align-items-center" v-if="infoClass.stateClass != null">
              <i class="material-icons-outlined mr-3">query_stats</i>
              <span style="font-weight:600" :style="{'color': (infoClass.color)}">{{infoClass.stateClassName}}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">account_circle</i>
              <span>{{ infoClass.personTeacherName }}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">schedule</i>
              <span>{{infoClass != null? getFormatDateComplete(infoClass.startDate,infoClass.endDate, this.lang,flagPlanTest,maximoHorasCalendario): ""}}</span>
            </p>
            <p class="d-flex align-items-center" v-if="flagPlanTest">
              <i class="material-icons-outlined mr-3">quiz</i>
              <span>{{$t('horario.calendario.plan-test')}}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">class</i>
              <span style="white-space: pre-line;">{{ infoClass.subjectsName }}</span>
            </p>
            <p class="d-flex align-items-center">
              <i class="material-icons-outlined mr-3">link</i>
              <span>{{ infoClass.linkClass ? infoClass.linkClass : "-" }}</span>
            </p>
            <div>
              <b-alert
                show
                variant="danger"
                style="padding: 5px; font-size: 0.7rem; text-align: center"
                v-if="showAlertModal"
                >{{ message }}</b-alert
              >
            </div>
            <b-alert show variant="danger" v-if="messageResult">{{ messageResult }}</b-alert>
            <template #modal-footer v-if="infoClass.stateClass && !arrStatusNotEditableLinkClass.includes(infoClass.stateClass)">
              <template v-if="infoClass.stateClass != '3'">
              <!--<b-button variant="link" @click="closeModalRemove">{{$t('horario.buttons.cancel')}}</b-button>-->
                
                  <b-button v-b-modal.modal-schedule-cancel-student v-show="isRepresentative && !flagPlanTest " variant="danger">
                  <template v-if="!showSpinnerSave">
                    {{$t('horario.buttons.cancel-classes')}}
                  </template>
                  <b-spinner style="width: 1rem !important; height: 1rem !important" v-else variant="light" label="Spinning" ></b-spinner>
                </b-button>
                
                  <b-button variant="primary" @click="viewClass(infoClass.linkClass)" :disabled="!infoClass.linkClass">
                  <icon name="video" aria-hidden="true"></icon>  {{$t('horario.modal-notes.button-enter-zoom')}}
                 
                </b-button>
              </template>
             
            </template>
           
          </b-modal>
          <b-modal id="modal-schedule-cancel-student" :centered="true" 
          :no-close-on-esc="true">
           <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
               <p class="text-center" >{{$t('modals.modalViewSchedule.modal-schedule-cancel.titulo-1')}}</p>  
            </template>

          <template #modal-footer>
              <b-button variant="danger"  @click="$bvModal.hide('modal-schedule-cancel-student')">{{$t('modals.modalViewSchedule.modal-schedule-cancel.button-cancel')}}</b-button>
            <b-button @click="cancelClass" variant="primary">
              <template v-if="!showSpinnerCancel">{{$t('modals.modalViewSchedule.modal-schedule-cancel.button')}}</template>
              <b-spinner
                style="width: 1rem !important; height: 1rem !important"
                v-else
                variant="light"
                label="Spinning"
              ></b-spinner>
            </b-button>
          
          </template>
				</b-modal>

        <b-modal id="modal-not-edit" :centered="true">
           <template #modal-header="{ close }">
              <img class="close" src="@/assets/img/close_red.png" @click="close()">
               <h5 style="text-align: center;" >{{$t('horario.calendario.text.6')}}</h5>  
            </template>
           
          <template #modal-footer>
           
            <b-button  @click="$bvModal.hide('modal-not-edit')" variant="primary">
              {{$t('modals.modalViewSchedule.modal-schedule-cancel.button')}}
           
            </b-button>
          
          </template>
				</b-modal>

            <b-modal id="modalTeacher" ref="modalTeacher"
            :hide-footer="true" 
            :hide-header="true" 
            :centered="true">
            <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modalTeacher')">
                <h6 class="sub-title"><span>{{$t('dashboard.modal-changue-teacher.titulo')}}</span></h6>
                <p class="text-center" v-if="groupsPlan" >{{$t('dashboard.modal-changue-teacher.text', {NRO: groupsPlan.limitTeacherChanges})}}</p>
                   <ul class="mt-4 list-ul pl-3 pr-3" v-if="teacherChangesInfo"> 
                        <li>{{$t('dashboard.modal-changue-teacher.options.1', {NRO:teacherChangesInfo.quantityTeacherChanges, VEZ: teacherChangesInfo.quantityTeacherChanges == 1 ? $t('reusables.time') : $t('reusables.times') , QUEDA:teacherChangesInfo.quantityTeacherChanges == 1 ? $t('reusables.queda')  : $t('reusables.quedan') , NRO2: groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges, S: groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges == 1 ? '': 's'})}} 
                        <li>{{$t('dashboard.modal-changue-teacher.options.2')}}</li>
                    </ul>
                
                  <div>
            

                </div>
                <div class="card card-body  mb-4 mt-4" v-if="teacher && teacher.person">
                    <!-- <b-avatar variant="info" :src="teacher.person.photo"></b-avatar> -->
                    <b-avatar v-if="teacher && teacher.person" variant="light" :src="teacher.person.photo ? teacher.person.photo : urlPhoto" class="mr-4"></b-avatar>
                    <div class="ml-3">
                        <p class="mb-0">{{$t('dashboard.modal-changue-teacher.card.text')}}</p>
                        <h6><span class="spanSubTitle">{{teacher.person.strFullName}}</span></h6>
                    </div>
                </div>
                <button type="button" class="btn btn-primary   d-block m-auto" 
                    :disabled="groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChangess == 0" @click="$bvModal.show('modalConfirmTeacher')">
                    <template>{{$t('dashboard.modal-changue-teacher.card.continue')}}</template>
                </button>
                <!--
                <button type="button" class="btn btn-primary  d-block m-auto" :disabled="groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges == 0" @click="changueTeacherMethod">
                    <span v-if="!showSpinnerChange" style="color:#ffffff;">{{$t('dashboard.modal-changue-teacher.card.continue')}}</span>
                <b-spinner
                  style="width: 1rem !important; height: 1rem !important ;"
                  v-else
                  variant="light"
                  label="Spinning"
                ></b-spinner>
                  </button>-->
            </b-modal>

            <b-modal 
                v-model="modalConfirmTeacher"
                id="modalConfirmTeacher" 
                :hide-footer="true"
                 :hide-header="true"  
                 >
                 <h6 class="sub-title"><span>{{$t('modals.modalConfirm.text-7')}}</span></h6>
                 <div class="d-block text-right">
                    <button class="btn btn-danger mr-3" style="display:initial" @click="$bvModal.hide('modalConfirmTeacher')">{{$t('modals.modalConfirm.button-cancel')}}</button>
                    <button type="button" class="btn btn-primary" :disabled="groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges == 0" @click="changueTeacherMethod">
                      <span v-if="!showSpinnerChange" style="color:#ffffff;">{{$t('modals.modalConfirm.button')}}</span>
                      <b-spinner
                        style="width: 1rem !important; height: 1rem !important ;"
                        v-else
                        variant="light"
                        label="Spinning"
                      ></b-spinner>
                    </button>
                 </div>
                 
            </b-modal>


            <b-modal id="modal-next-linkClass" :centered="true">
              <template #modal-header="{ close }">
                <img class="close" src="@/assets/img/close_red.png" @click="close()">
              </template>
              <p class="text-center mb-0" >{{ messageLinkClassResult }}</p>
              <template #modal-footer>
                  <b-button @click="$bvModal.hide('modal-next-linkClass')" variant="primary">Aceptar</b-button>
              </template>
            </b-modal>
	
    </div>
      <!--:key="`class-modal-schedule-2`"-->
     <viewSchedule :showActions="false"  
     @updateSchedule="updateListStrudent" 
     ref="viewScheduleModal"  @value="getShowModalPerson = $event"  
     @listenTeacherInfoComments="getTeacherInformationAndComments" 
     />
    <modalTeacher :teacherInformation="teacherInformation" :flagEdit="false"/>
    <modalChangeTimeZone @updateCalendar='reloadData()'/>
  </div>
</template>
<script>
import CustomSelect from "@/components/form/select";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { baseInstanceAxios } from "@/assets/js/axiosBase.js";
import * as Constants from "@/assets/js/appConstants";
import modalTeacher from "@/components/modals/commentary";
import { redirectHorario, horarioObtenerColorClase,getCalendarHeaderFormat,
        getCalendarTitle, getFormatDate, getFormatDateComplete, getCalendarEventTimeFormat,getCalendarHeaderToolbar ,
        openLinkClass,horarioObtenerNameClaseEnEs, getNextClassDate, getNextClassTime, convertToUserTimeCalendarEvents, getHoursByTimeZoneName, convertTimeToUserTimeFormat, convertTimeCalendarEvents} from '@/assets/js/util.js';
import viewSchedule from "@/components/modals/view-schedule";
import modalChangeTimeZone from "@/components/modals/ModalChangeTimeZone";
import { required } from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';

let eventGuid = 0;
export function createEventId() {
  return String(eventGuid++);
}

const formUpdateDateMessages = {
  requiredFecha: function (){
    return this.$t('reusables.obligatoryField')
  }
} 

export default {
  components: {
    viewSchedule,
    FullCalendar,
    modalTeacher,
    CustomSelect,
    modalChangeTimeZone
  },
  	props: {
		backStep: {
			type: Function,
			default() {
				return {}
			}
		},
	},
  data(){
    
    return {
      urlPhoto: Constants.IMAGENES.PHOTO_TEACHER_DEFAULT,
      messageResult: null,
      messageLinkClassResult: null,
      dateStartValidate:null,
      dateEndValidate:null,
      dateStartValidateNext : null,
      dateEndValidateNext : null,
      showSpinnerCancel:false,
      dismissSecs: 5,
      dismissCountDown: 0,
      selectTimeInit : 0,
      daysMaxSchedule : 0,
       maximoHorasCalendario: 0,
      flagShowHeader:true,
      lang: localStorage.getItem('lang') || 'es',
      showSpinnerSasve:false,
      teacher:{},
      groupsPlan : {},
      teacherChangesInfo: {},
      showSpinnerChange:false,
      arrayEditableSchedule: [],
      groupsScheduleProposalEditedId: null,
      groupScheduleStrundetId : null,
      showEditSchedule:false,
      proposalId :null,
      showSpinnerSend:false,
      personTeacherId: 0,
      arrayCalendarChange: [],
      showReadonly : null,
      disabledDate:true,
       minDate: null,
      maxDate : null,
       GroupId: 0,
      SelectBeginningDateChange: new Date(),
      SelectBeginningDateInit : new Date(),
      SelectBeginningDate : new Date(),
      arrayCalendarInit: [],
      showSelectWeek:true,
      uniqDateEnabled : [],
      showLoadingCalendar : false,
      uniqDate: [],
      optionsTime:  [],
      selectedTime : null,
      nroHoursAnticipationLessonCancel : 0,
      showSpinnerSaveSchedule: false,
      flaganticipation : false,
      nroClaseCancelarSemana: 0,
      flagEdit : false,
      flagPlanTest : false,
      showLoadingFirst:true,
      nextDateClass : null,
      nextClass : null,
      dataTeacher : {},
      infoClass :{},
      showSpinnerSave:false,
      message: '',
      titleCourse: '',
      eventCreated: null,
      showLoading:false,
      showAlertModal: false,
      listCalendar : [],
      formatDay : "DD",
      new_appointment: {
        title: null,
        description: null,
      },
      calendarOptions: {
        customButtons: { 
          today: { 
            text: `${this.$t('reusables.today')}`, 
            click: () => {           
              this.selectedTime = this.selectTimeInit;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.gotoDate(new Date())
             
            }
          },
          prev: { 
            text: "PREV", 
            click: () => {           
              this.selectedTime--;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.prev();
              
            }
          },
          next: { 
            text: "NEXT",
            click: () => {
              this.selectedTime++;
              let calendarApi = this.$refs.fullCalendarStudent.getApi();
              calendarApi.next();
              
            }
          }
        },
        fixedWeekCount : true,
        plugins: [
          dayGridPlugin,
          timeGridPlugin,
          interactionPlugin, // needed for dateClick
        ],
        events: [],
        eventOverlap: false,
        themeSystem: "bootstrap",
        nowIndicator: true,
        firstDay : 1,
        headerToolbar: getCalendarHeaderToolbar(this.flagShowHeader),
        buttonText:{
          today: this.$t('reusables.today'), 
        },
        titleFormat: function(date) {
         
          return getCalendarTitle(date.date, this.lang);
        },
        height: "auto",
        allDaySlot: false,
        viewDidMount: (view) => {
            let GMT = getHoursByTimeZoneName(this.$moment, this.$store.state.user.timeZoneName);
            view.el.querySelector('.fc-timegrid-axis-frame').innerHTML = GMT;
            view.el.querySelector('.fc-timegrid-axis-frame').addEventListener("click", () => {
              this.$bvModal.show("modal-change-time-zone");
            });
        },
        initialView: "timeGridWeek",
        dayHeaderContent: (args) => {
          return getCalendarHeaderFormat(this.$moment, args.date, this.lang,this.formatDay);
        },
        eventTimeFormat: getCalendarEventTimeFormat(),
        initialEvents: [], //INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
        editable: false,
        scrollTimeReset:false,
        isLoading :true,
        eventColor:  Constants.CALENDAR_STATUS.CONFIRM.COLOR,
        selectAllow: this.handleSelecAllow,
        selectable: false,
        selectMirror: true,
        dayMaxEvents: true,
        weekends: true,
        eventResizableFromStart: false,
        select: this.handleDateSelect,
        //eventClick: this.handleEventClick,
        eventChange: this.handleEvents,
      },
      hideButtonsForEdit: false,
      teacherInformation:null,
      getFormatDate:getFormatDate,
      getFormatDateComplete:getFormatDateComplete,
      openLinkClass:openLinkClass,
      linkClass: "",
      arrStatusNotEditableLinkClass: [
        Constants.CALENDAR_STATUS.COMPLETED.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.CANCELED_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.PENDING_REPORT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_STUDENT.VALUE,
        Constants.CALENDAR_STATUS.UNATTENDANCE_TEACHER.VALUE,
        Constants.CALENDAR_STATUS.FROZEN.VALUE
      ],
      TYPE_SCHEDULE : Constants.TYPE_SCHEDULE,
      formatDate : (localStorage.getItem('lang') || 'es')  == 'es' ? "DD/MM/YYYY" : "MM/DD/YYYY" ,
      modalConfirmTeacher: false
    };
  },
  validations :{
    SelectBeginningDate:{
      requiredFecha(value) {
        return (required(value))                                          
      },
    }
  },
  async created() {
  
    this.GroupId = this.$store.state.group_id;
    this.getDataPlan();
    
    redirectHorario(this.$store.state.datosSidebar.typeScheduled,this,this.$store.state.is_representative);
    if(this.$store.state.datosSidebar.typeScheduled == Constants.TYPE_SCHEDULED.SCHEDULED){
      this.getDateMinMax(new Date());
      
      this.showLoadingFirst = true;
    
      await this.getCourses()
      
      this.getListScheduleClass();
      this.getDashboardData();
    }

    
    
  },
  mounted(){
  
  },
  methods: {
    reloadData(){
      this.getListScheduleClass();
      this.getDashboardData();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
      showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
     getDataPlan(){
      let data = {
        GroupId : this.GroupId 
      }
      baseInstanceAxios.get(`${this.apiURL}/resources/GroupsCoursesLessons/EntitySchedulePlanTest`,
        {
          params: data
        }).then(response => {
        
          if(response.data.entity){
                this.maximoHorasCalendario = response.data.entity.maximoHorasCalendario
               this.flagPlanTest = response.data.entity.flagPlanTest
               this.daysMaxSchedule = response.data.entity.daysMaxSchedule + 1
              this.flagShowHeader = true;
              // this.formatDay = ' '
              if(response.data.entity.flagPlanTest){
                this.flagShowHeader = false;
                 //this.formatDay = 'DD'
                this.maximoHorasCalendario = response.data.entity.durationClassTest/60
                
                /*this.calendarOptions.validRange = {
                  start: this.$moment().format('YYYY-MM-DD'),
                  end: this.$moment().add(this.daysMaxSchedule, 'days').format('YYYY-MM-DD'),
                };*/
             
              }else{
                /*this.calendarOptions.validRange = {
                  start: null,
                  end: null,
                };*/
             
              }
          
              this.calendarOptions.headerToolbar =  getCalendarHeaderToolbar(this.flagShowHeader);
          }
        
      })
    },
     openLinkClassLocal(linkClass){
      this.messageLinkClassResult = null;
      let result = openLinkClass(linkClass,this.$moment,this.dateStartValidateNext,this.dateEndValidateNext,this.$store.state.user.timeZoneName);
       if(result != ""){
         this.messageLinkClassResult = result;
         this.$bvModal.show("modal-next-linkClass");
        }
     },
      viewClass(urlClass){
        let result = openLinkClass(urlClass,this.$moment,this.dateStartValidate,this.dateEndValidate,this.$store.state.user.timeZoneName);
        if  (result != ""){
          this.messageResult = result;
         }
       },
    getDashboardData(){
            
            baseInstanceAxios
                .get(`${this.apiURL}/resources/dashboard/GetStudentConsolidatedById?personStudentId=${this.$store.state.user.personStudentId}`)

                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        this.groupsPlan = response.data.entity.groupsPlan;  
                      
                          if(this.groupsPlan != null){
                            if(response.data.entity.flagTeacher){
                                this.teacher = response.data.entity.personsTeachers;  
                                
                            }
                        }
                    }
                });
    },
    getTeacherChanges: function() {
          var datos = {
              id: this.groupsPlan.id
          };
          baseInstanceAxios
              .post(`${this.apiURL}/resources/Dashboard/GetQuantityGroupsPlanTeacherChanges`, datos)
              .then(response => {
          
                  if(response.data != null && response.data.entity != null){
                      this.teacherChangesInfo = response.data.entity;
                      this.$bvModal.show('modalTeacher')

                  }
              }); 
    }, 
   
    updateListStrudent(){
        this.reply();
    },
    
    modalSchedule(){
        console.log("class calendar - modalSchedule")
        this.$refs.viewScheduleModal.showModalEditStudent(true,this.dataTeacher,this.groupsScheduleProposalEditedId,this.flagPlanTest)
    }, 
    changueTeacherMethod(){
      this.showSpinnerChange = true;
       let data = {
              ScheduleId: this.groupScheduleStrundetId,
              groupId : this.$store.state.group_id,
              Usuario : this.$store.state.user.email
              //BeginningDate: this.SelectBeginningDateChange
          };
      
          baseInstanceAxios.get(`${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleTeacherChanges`,
          {params:data }).then(response => {

          this.$store.state.datosSidebar.typeScheduled = 1
           this.$store.state.datosSidebar.flagEdited = true;
          this.$router.push({ path: '/horario/calendario/public'})
          this.showSpinnerChange = false;
          this.$bvModal.hide('modalConfirmTeacher');
           
        }).catch(err =>{
					this.showSpinnerSave = false;
					this.message = this.$t('horario.error-changing-teacher');
					
					this.$bvToast.show("toast-equis-modal-calendar-class");
          this.$bvModal.hide('modalConfirmTeacher');
        }) ;
       
    },
    handleEvents(events) {
      
        let newEvents = events.event;
      let oldEvent = events.oldEvent;
 
      let fechaInicio = newEvents.startStr;
      let fechaFin = newEvents.endStr;
      let dateNow = new Date();
      let startDate = new Date(fechaInicio);
      let endDate = new Date(fechaFin);
      let dateNowFormat = new Date(dateNow.getFullYear(),dateNow.getMonth(),dateNow.getDate(),0,0,0);
      let d = new Date(dateNowFormat);
      d = d.getDay() == 0 ? new Date(d.setDate(d.getDate() + 1)) : d;
 
     
      if(this.flagPlanTest){
      
          let dataAfter = this.$moment().add(this.daysMaxSchedule , 'days').format("YYYY-MM-DD")
          let dataStar = this.$moment(fechaInicio).format("YYYY-MM-DD")
          let valueBefore = this.$moment(dataStar).isBefore(dataAfter);
          let valueAfter = this.$moment(new Date(fechaInicio)).isAfter(new Date());

        
       
          if(valueBefore && valueAfter){
            let dateSelectStart =new Date(fechaInicio)
         
            let dateAfter = (new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60)))
        
            this.listCalendar = this.listCalendar.filter(function (e) {
             return  new Date(e.StartDate).getTime() !=
                new Date(oldEvent.startStr).getTime() &&
              new Date(e.EndDate).getTime() != new Date(oldEvent.endStr).getTime()

              //return (e.id != parseInt(oldEvent.extendedProps.idx) );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
               return  new Date(e.start).getTime() != new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(oldEvent.endStr).getTime()
               // return ( parseInt(e.id) != parseInt(oldEvent.id) );
              }
            )
            events.event.remove();
            
            let dataTmp = this.listCalendar;
            let idx = 0;
            let ultId = dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
            ultId = ultId == null ? 0 : ultId;
            idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;
            let data2 = {
              id: idx,
              StartDate: newEvents.startStr,
              EndDate:dateAfter,
              request:true,
              flagPlantTest:false,
            };
            this.listCalendar.push(data2);

            this.calendarOptions.events.push({
              idx: idx,
              id: createEventId(),
              start: newEvents.startStr,
              end: this.$moment(dateAfter).format('YYYY-MM-DDTHH:mm:ss'),
              title: this.titleCourse,
              editable: true,
            });

          
          }else{
              //let dateSelectStart =new Date(oldEvent.startStr)
              //let dateAfter = (new Date(dateSelectStart.setHours(dateSelectStart.getHours()+1)))
              this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                  return  new Date(e.start).getTime() != new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(oldEvent.endStr).getTime()
                //return ( parseInt(e.id) != parseInt(oldEvent.id) );
              })
          
              events.event.remove();
              this.calendarOptions.events.push({
                id: createEventId(),
                idx: oldEvent.extendedProps.idx,
                start: oldEvent.startStr,
                end: oldEvent.endStr,
                title: this.titleCourse,
                editable: true,
              });
           
          }
      }else{
          /*let valueAfter = this.$moment(new Date(fechaInicio)).isAfter(new Date());
          if(valueAfter){
             }else{
             
  
              this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
                return ( parseInt(e.id) != parseInt(oldEvent.id) );
              })
          
              events.event.remove();
              this.calendarOptions.events.push({
                id: createEventId(),
                idx: oldEvent.extendedProps.idx,
                start: oldEvent.startStr,
                end: oldEvent.endStr,
                title: this.titleCourse,
                editable: true,
              });
          }*/
            let dateSelectStart =new Date(fechaInicio)
            let dateSelectEnd = new Date(fechaFin)
            let dateEnd = null
            let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
       
            if(dateSelectEnd.getTime() <dateAfter.getTime()){
              dateEnd = fechaFin
            }else{
              dateEnd = dateAfter
            }

             this.listCalendar = this.listCalendar.filter(function (e) {

              return  new Date(e.StartDate).getTime() != new Date(oldEvent.startStr).getTime() &&
              new Date(e.EndDate).getTime() != new Date(oldEvent.endStr).getTime()

              //return (e.id != parseInt(oldEvent.extendedProps.idx) );
            });
            this.calendarOptions.events = this.calendarOptions.events.filter(
              function (e) {
           
            
              return   new Date(e.start).getTime() != new Date(oldEvent.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(oldEvent.endStr).getTime()
               // return ( parseInt(e.id) != parseInt(oldEvent.id) );
              }
            )

            events.event.remove();
            let dataTmp = this.listCalendar;
            let idx = 0;
            let ultId = dataTmp.length == 0 ? 1 * -1000 : dataTmp[dataTmp.length - 1].id;
            ultId = ultId == null ? 0 : ultId;
            idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;
            let data2 = {
              id: idx,
              StartDate: newEvents.startStr,
              EndDate: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss')  ,
              request:true,
              flagPlantTest:false,
            };
            this.listCalendar.push(data2);

            this.calendarOptions.events.push({
              idx: idx,
              id: createEventId(),
              start: newEvents.startStr,
              end: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
              title: this.titleCourse,
                editable: true,
            });
         

         
      }

    },
    getDateMinMax(minDateArray){
        this.minDate= new Date(minDateArray) 
 
        let d = new Date(minDateArray),     
        diff = d.getDate() + 7 //TODO:Validar param
        this.maxDate= new Date(d.setDate(diff))

    },
    saveChange(){
      this.$v.$touch();
      if (this.$v.$invalid) {
                    return;
      }
      
      this.showSpinnerSend = true;
      let arraySchedule = [];

      let arraySend = this.listCalendar.filter((currentValue)=>{
        return currentValue.request 
      }) 
      if(this.flagPlanTest){
        this.SelectBeginningDate = arraySend[0].StartDate
      }
     arraySend.forEach(element => {
          let json = {
            StartDate: this.$moment(element.StartDate).format('YYYY-MM-DDTHH:mm:ss')   ,
            EndDate:  this.$moment(element.EndDate).format('YYYY-MM-DDTHH:mm:ss') ,
            StateClassId:  parseInt(Constants.CALENDAR_STATUS.CONFIRM.VALUE)
          }
          arraySchedule.push(json)
      });
      
      let jsonData  = {
            Schedule: {
                id: this.proposalId,
                BeginningDate: this.SelectBeginningDate
            },
            ScheduleDetail: arraySchedule,
            UserMail : this.$store.state.user.email
      }
convertTimeCalendarEvents(jsonData.ScheduleDetail, this.$store.state.user.timeZoneName, this.$moment);
      
     baseInstanceAxios
      .post(`${this.apiURL}/resources/GroupScheduleCounterProposal/SaveEditionSchedule`,jsonData)
      .then(response => {
        this.message = this.$t('valid.changes-saved-correctly');
        this.$bvToast.show("toast-check-modal-calendar-class");
        this.showSpinnerSend = false;
        this.$bvModal.hide('modal-save-change');
        this.showLoadingCalendar = true;
        this.reply();
      
      }).catch((error) => {
        this.message = this.$t('error.error-saving-changes');
        this.$bvToast.show("toast-equis-modal-calendar-class");
        this.showSpinnerSend =  false;
          
      });
    },
    removeEvent(event) {
       
        this.arrayCalendarChange = this.arrayCalendarChange.filter(function (e) {
             return (
              new Date(e.StartDate).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
            );
        });
        this.listCalendar = this.listCalendar.filter(function (e) {
            return (
              new Date(e.StartDate).getTime() !=
                new Date(event.startStr).getTime() &&
              new Date(e.EndDate).getTime() != new Date(event.endStr).getTime()
            );
          });
        this.calendarOptions.events = this.calendarOptions.events.filter(
          function (e) {
            return (
              new Date(e.start).getTime() != new Date(event.startStr).getTime() &&
              new Date(e.end).getTime() != new Date(event.endStr).getTime()
            );
          }
        );

      
        let arrayDateFormat = []
        if(this.arrayCalendarChange.length>0){
            this.disabledDate = false;
            this.getDateMinMax(new Date());
          /*  this.arrayCalendarChange.forEach(element => {
            let month = (parseInt(new Date(element.StartDate).getMonth())+1) <10 ? `0${parseInt(new Date(element.StartDate).getMonth())+1}` : parseInt(new Date(element.StartDate).getMonth())+1
            let day = parseInt(new Date(element.StartDate).getDate()) < 10  ? `0${parseInt(new Date(element.StartDate).getDate())}` : parseInt(parseInt(new Date(element.StartDate).getDate()))
            arrayDateFormat.push(new Date(new Date(element.StartDate).getFullYear()+"/"+month+"/"+day))
          });

          const minDateArray = new Date(Math.min(...arrayDateFormat));
          this.SelectBeginningDate = minDateArray*/
          
        }else{
          this.disabledDate = true;
          this.SelectBeginningDate = new Date(); 
        }
      
        event.remove();

 
    },
    idValueSelectEventSelectedTime(event){
      
      this.selectedTime = event;
    
    },
    getWeek(){
        let calendarApi = this.$refs.fullCalendarStudent.getApi(); 
        calendarApi.gotoDate(this.uniqDate[this.selectedTime]);
        console.log(this.optionsTime)
       
    },
    
    handleSelecAllow(selectInfo){
      let num = this.ObtenerRangoFecha(selectInfo.startStr,  selectInfo.endStr)

      if(num > 0){
        return false
      }

      let valueBefore = true;
      let valueAfter = this.$moment(new Date(selectInfo.start)).isAfter(new Date());
    
      if(this.flagPlanTest){
        let endAfterDate = selectInfo.end
        let dateSelectStart =new Date(selectInfo.start)
        let arraySend = this.listCalendar.filter((currentValue)=>{
          return currentValue.request 
        })
    
        if(arraySend.length==1){
          return false;
        }
        let dataStar = this.$moment(selectInfo.start)
        let dateCurrent = new Date();
        let newDateCurrent = new Date(dateCurrent.setMinutes(dateCurrent.getMinutes()-2*(this.maximoHorasCalendario*60)))
        let dataAfter = this.$moment(newDateCurrent).add(this.daysMaxSchedule-1, 'days')
        valueBefore = this.$moment(dataStar).isBefore(dataAfter);

        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
      
        if(new Date(endAfterDate).getTime() <= dateAfter.getTime() && (valueBefore && valueAfter)){
          return true
        }else{
          return false
        }

      }else{
    
        //let dataStar = this.$moment(selectInfo.start).format("YYYY-MM-DD")
        let dateSelectStart =new Date(selectInfo.start)
        let endAfter = selectInfo.end
        
        let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
        
        if(endAfter.getTime() <=dateAfter.getTime()){
    
          return true
        }else{
        
          return false
        }
  
      }
    

    },
     closeModal() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-add-event");
    },
  
    saveEvent(){
        let fechaInicio = this.eventCreated.startStr;
        let fechaFin = this.eventCreated.endStr;

        this.editHourTotal += this.hoursEdit
        let dataTmp = this.listCalendar;
        let idx = 0;

        let ultId =
          dataTmp.length == 0
            ? 1 * -1000
            : dataTmp[dataTmp.length - 1].id;
        ultId = ultId == null ? 0 : ultId;
        idx = ultId > 0 ? dataTmp.length * -1000 : ultId - 1000;
        //let currentStart = new Date(fechaInicio)
        let dateSelectStart =new Date(fechaInicio)
        let dateSelectEnd = new Date(fechaFin)
        let dateEnd = null
 
        if(this.flagPlanTest){
           let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
           dateEnd = dateAfter
        }else{
          let dateAfter = new Date(dateSelectStart.setMinutes(dateSelectStart.getMinutes()+this.maximoHorasCalendario*60))
          if(dateSelectEnd.getTime() <dateAfter.getTime()){
            dateEnd = fechaFin
          }else{
            dateEnd = dateAfter
          }
        }
     

        let num = this.ObtenerRangoFecha(fechaInicio,  dateEnd,this.listCalendar)
        if(num == 0){
             //currentStart = currentStart.setHo
          let data2 = {
            id: idx,
            StartDate: this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
            EndDate: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            StateClass : Constants.CALENDAR_STATUS.CONFIRM.VALUE,
            request:true
          };
          this.arrayCalendarChange.push(data2);
          this.listCalendar.push(data2);
          this.calendarOptions.events.push({
            idx: idx,
            id: createEventId(),
            start:  this.$moment(fechaInicio).format('YYYY-MM-DDTHH:mm:ss'),
            description: "",
            end: this.$moment(dateEnd).format('YYYY-MM-DDTHH:mm:ss'),
            title: '',
            editable:true
          });
          this.disabledDate = false;
          /*let arrayDateFormat = []
          this.arrayCalendarChange.forEach(element => {
            let month = (parseInt(new Date(element.StartDate).getMonth())+1) <10 ? `0${parseInt(new Date(element.StartDate).getMonth())+1}` : parseInt(new Date(element.StartDate).getMonth())+1
            let day = parseInt(new Date(element.StartDate).getDate()) < 10  ? `0${parseInt(new Date(element.StartDate).getDate())}` : parseInt(parseInt(new Date(element.StartDate).getDate()))
            arrayDateFormat.push(new Date(new Date(element.StartDate).getFullYear()+"/"+month+"/"+day))
          });
        
          const minDateArray = new Date(Math.min(...arrayDateFormat));
          this.SelectBeginningDate = minDateArray*/
          this.getDateMinMax(new Date());
          this.$bvModal.hide("modal-add-event");
        }else{
          this.message = `${this.$t('modals.modalViewSchedule.maximoHorasCalendario.1')} ${this.maximoHorasCalendario*60} ${this.$t('modals.modalViewSchedule.maximoHorasCalendario.2')} `;
					this.$bvToast.show("toast-equis-modal-calendar-class");
        }

         this.$bvModal.hide("modal-add-event");
    },
    cancelClass(){
      this.showSpinnerCancel = true;
   
      let data = {
        GroupScheduleStudentsDetailsId : this.infoClass.id ,
        FlagTipo: true,
        FlagTipoCancelacion : this.flaganticipation ,
        TeacherId : this.infoClass.personTeacherId ,
        User : this.$store.state.user.email
				};



         baseInstanceAxios.get(`${this.apiURL}/resources/GroupScheduleStudents/GetScheduleCancelByTeacherStudent`,
          {
            params: data
          }).then(response => {
    
            this.showSpinnerCancel = false;
            this.$bvModal.hide("modal-class-info");
            this.$bvModal.hide("modal-schedule-cancel-student");
            let format_time_validate = "YYYY-MM-DDTHH:mm:ss";
            switch (response.data.value) {
              case 0:
                this.message = this.$t('reusables.empty-text')
                this.$bvToast.show("toast-equis-modal-calendar-class");
                break;
              case 1:
                if(response.data.list != null && response.data.list.length > 0){
                  this.dateStartValidateNext = response.data.list[0] != null ? 
                                           convertTimeToUserTimeFormat(response.data.list[0].startDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate) : "";              
                  this.dateEndValidateNext = response.data.list[0] != null ? 
                                         convertTimeToUserTimeFormat(response.data.list[0].endDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate) : "";
                  //PARSEAR FECHA DE PROXIMA CLASE AL HORARIO DEL ALUMNO 
                  let format_day = "DD/MM/YYYY";
                  let format_time = "h:mm a";
                
                  this.nextDateClass = getNextClassDate(response.data.list[0].startDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                  this.nextClass =  getNextClassTime(response.data.list[0].startDate, response.data.list[0].endDate,this.$store.state.user.timeZoneName, this.$moment, format_time);
              
                  this.nextClassLink = response.data.entity.groupScheduleStudentsDetails != null ? response.data.list[0].linkClass : null;
                }else{
                  this.nextDateClass = "";
                  this.nextClass =  "";
                }
                 this.message = this.$t('reusables.records-have-been-updated')
                 	this.$bvToast.show("toast-check-modal-calendar-class");
                  this.reply();
                 break;
              case -1:
                 this.message = this.$t('reusables.class-was-not-found')
                 	this.$bvToast.show("toast-equis-modal-calendar-class");
                 break;
              case -2:
                 this.message = this.$t('reusables.exceed-cancellation-number')
                 	this.$bvToast.show("toast-equis-modal-calendar-class");
                 break;
              case -3:
                 this.message = this.$t('reusables.cannot-cancel-class-finished');
                  this.$bvToast.show("toast-equis-modal-calendar-class");
                 break;
             
             }
          
           
           
        }).catch(err =>{
				  this.showSpinnerCancel = false;
					this.message = this.$t('reusables.error-canceling-class');
					
					this.$bvToast.show("toast-equis-modal-calendar-class");

        }) ;
    },

 
    editCalendar(){
     
      /*this.calendarOptions.events.forEach(element => {
              //element.editable = true;
              element.color =  Constants.CALENDAR_STATUS.CONFIRM.COLOR;
      });*/

       /*this.arrayEditableSchedule.forEach(id => {
            this.calendarOptions.events.forEach(element => {
              if(element.idx==id){
                element.editable = true;
              }
            });
        });*/
      this.hideButtonsForEdit = true;
      this.formatDay = ''
      if(this.flagPlanTest){
         this.formatDay = 'DD'
      }
      this.calendarOptions.headerToolbar = {
          left: "",
          center:  '',
          right:'',
      }
     
      let data = {
          PersonTeacherId :  this.personTeacherId,
          GroupId : this.dataGroup,
          timeZoneName: this.$store.state.user.timeZoneName
          //dateTime :  this.$moment(this.uniqDate[this.selectedTime]).format("YYYY-MM-DD")
      }
    
      baseInstanceAxios
        .get(
            `${this.apiURL}/resources/PersonsTeachers/GetScheduleEditedConsolidatedByStudent` ,
            {
              params : data
            }
           
        )
        .then((response) => {
          console.log("response.data.entity: ",response.data.entity)
          if(response.data.entity != null){
            this.$bvModal.show('modal-not-edit')
           // this.showAlert();
          }else{  
              this.listCalendar = [];
              this.arrayCalendarInit = [];
              this.calendarOptions.events = [];
              this.disabledDate = true,
              this.flagEdit = true;
              this.calendarOptions.selectable = true;
              this.showSelectWeek = false;
              let arrayList = response.data.list

              arrayList.forEach(element => {
          
                let jsonData = {
                  id: createEventId(),
                  title: element.flagUpdate ? this.$t('horario.calendario.label-calendar-teacher', {TeacherName: this.dataTeacher.firstName}) :   this.$t('reusables.unavailable'),
                  description: "",
                  idx: element.id,
                  start: element.startDate,
                  end: element.endDate,
                  color:  element.flagUpdate ?  Constants.CALENDAR_STATUS.CONFIRM.COLOR : Constants.CALENDAR_STATUS.UNAVAILABLE.COLOR,
                  editable: element.flagUpdate
                };
            
                let data = {
                  id: element.id,
                  StartDate: element.startDate,
                  EndDate: element.endDate,
                  request:element.flagUpdate,
                };
              
                this.listCalendar.push(data);
                this.arrayCalendarInit.push(data)
                this.calendarOptions.events.push(jsonData);
          
              })
              let startOfWeek = this.$moment().startOf('week').toDate();
              let endOfWeek = this.$moment().endOf('week').toDate();
      
          
              let month = (parseInt(startOfWeek.getMonth())+1) <10 ? `0${parseInt(startOfWeek.getMonth())+1}` : parseInt(startOfWeek.getMonth())+1;
              let dayDate = parseInt(startOfWeek.getDate()) < 10  ? `0${parseInt(startOfWeek.getDate())}` : parseInt(parseInt(startOfWeek.getDate()));

              let monthEnd = (parseInt(endOfWeek.getMonth())+1) <10 ? `0${parseInt(endOfWeek.getMonth())+1}` : parseInt(endOfWeek.getMonth())+1;
              let dayDateEnd = parseInt(endOfWeek.getDate())+1 < 10  ? `0${parseInt(endOfWeek.getDate())+1}` : parseInt(parseInt(endOfWeek.getDate())+1);
                
              this.calendarOptions.validRange =  {
                          start: startOfWeek.getFullYear()+'-'+month+'-'+dayDate,
                          end: endOfWeek.getFullYear()+'-'+monthEnd+'-'+dayDateEnd
              }
            
              setTimeout(() => {
                if(this.listCalendar.length>0){
                  
                    let calendarApi = this.$refs.fullCalendarStudent.getApi(); 
                    calendarApi.gotoDate(new Date());
                }
              }, 500);
       
          }
      
         
        });
     
    },
    reply(){
      this.disabledDate = true,
      this.showSelectWeek = true;
      this.calendarOptions.headerToolbar =  getCalendarHeaderToolbar(this.flagShowHeader);
      this.formatDay = 'DD'
      this.flagEdit = false;
      this.calendarOptions.selectable = false;
      this.showLoadingCalendar = true;
      this.getListScheduleClass();
    },
    async getDataClass(data){ 
      //console.log("data: ",data)
      this.dateStartValidate = null;
         this.dateEndValidate = null;
         this.messageResult="";
      await baseInstanceAxios
      .get(
          `${this.apiURL}/resources/GroupScheduleStudents/GetScheduleStudentByiD?scheduleId=` +
          data["_def"].extendedProps.idx
      )
      .then((response) => {

        this.listCalendar.filter(function(e){
        
          if(e.id ==  data["_def"].extendedProps.idx){
            
              e.StateClass = response.data.entity.stateClass.value
          }
        })
        let colorResquest = horarioObtenerColorClase(response.data.entity.stateClass.value);
        this.calendarOptions.events.filter(function(e){
             if(e.idx ==  data["_def"].extendedProps.idx){
              e.color= colorResquest
              e.stateClass = response.data.entity.stateClass.value
              e.stateClassName = response.data.entity.stateClass.name
          }
        })      
         let format_time_validate = "YYYY-MM-DDTHH:mm:ss";

        this.dateStartValidate = convertTimeToUserTimeFormat(response.data.entity.startDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate);
        this.dateEndValidate = convertTimeToUserTimeFormat(response.data.entity.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate);

          if(!this.flagEdit){
            
            let json = {
              subjectsName : data["_def"].extendedProps.subjectsName,
              startDate : data.startStr,
              endDate : data.endStr,
              id : data["_def"].extendedProps.idx,
              personTeacherId : data["_def"].extendedProps.personTeacherId,
              personTeacherName: data["_def"].extendedProps.personTeacherNameFull,
              /*color :data.backgroundColor,
              stateClass: data["_def"].extendedProps.stateClass,
              stateClassName : data["_def"].extendedProps.stateClassName,*/

              color :colorResquest,
              stateClass: response.data.entity.stateClass.value,
              stateClassName : horarioObtenerNameClaseEnEs(response.data.entity.stateClass.value),
              linkClass: data["_def"].extendedProps.linkClass,
              flagGroup : data["_def"].extendedProps.flagGroup,
            }
          
            let newDate = new Date(data.startStr)
        
      
            newDate.setHours(newDate.getHours() - this.nroHoursAnticipationLessonCancel);

            let currentDate = new Date()

            if(currentDate.getTime()>newDate.getTime()){
              this.flaganticipation = true;
            }else{
              this.flaganticipation = false;
            }

            this.infoClass = json


            this.$bvModal.show("modal-class-info");
          }
      });
      
    },
    async getCourses() {
      await baseInstanceAxios
        .get(
            `${this.apiURL}/resources/GroupRegisterSubjects/GetByGroupId?GroupsId=` +
            this.dataGroup
        )
        .then((response) => {
          if (response.data) {
            if (response.data.entity) {
                this.titleCourse = response.data.entity.subjectsName.replace(",", "\n");
            }
          }
        });
    },

    getListScheduleClass(){

        this.listCalendar = [];
        this.arrayCalendarInit = [];
      	let data = {
          GroupId : this.dataGroup,
          IdPersonStudent: this.$store.state.user.personStudentId,
          flagLanguage: this.lang == 'es' ? true : false,
    		}
        
        baseInstanceAxios.get(`${this.apiURL}/resources/GroupScheduleStudents/GetScheduleStudentByGroup`,
          {
            params: data
          }).then(response => {
          
            if(response.data.entity){
              let format_time_validate = "YYYY-MM-DDTHH:mm:ss";

              this.groupScheduleStrundetId= response.data.entity.id
              this.showEditSchedule = response.data.entity.flagProposalEdited
              this.groupsScheduleProposalEditedId = response.data.entity.groupsScheduleProposalEditedId
              this.proposalId = response.data.entity.groupScheduleProposalId
              this.personTeacherId = response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.id : null
              this.SelectBeginningDateInit = response.data.entity.beginningDate
              this.SelectBeginningDate = ''
              this.flagPlanTest= response.data.entity.flagPlanTest;
              this.nroHoursAnticipationLessonCancel = response.data.entity.nroHoursAnticipationLessonCancel;
              this.dateStartValidateNext = response.data.entity.groupScheduleStudentsDetails != null ? 
                                           convertTimeToUserTimeFormat(response.data.entity.groupScheduleStudentsDetails.startDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate) : "";              
              this.dateEndValidateNext = response.data.entity.groupScheduleStudentsDetails != null ? 
                                         convertTimeToUserTimeFormat(response.data.entity.groupScheduleStudentsDetails.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time_validate) : "";
              this.hideButtonsForEdit = false;
              //PARSEAR FECHA DE PROXIMA CLASE AL HORARIO DEL ALUMNO 
              if(response.data.entity.groupScheduleStudentsDetails != null){
                let format_day = "DD/MM/YYYY";
                let format_time = "h:mm a";
              
                this.nextDateClass = getNextClassDate(response.data.entity.groupScheduleStudentsDetails.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                this.nextClass =  getNextClassTime(response.data.entity.groupScheduleStudentsDetails.startDate, response.data.entity.groupScheduleStudentsDetails.endDate,this.$store.state.user.timeZoneName, this.$moment, format_time);
              }else{
                this.nextDateClass = "";
                this.nextClass =  "";
              }
              this.nextClassLink = response.data.entity.groupScheduleStudentsDetails != null ? response.data.entity.groupScheduleStudentsDetails.linkClass : null;
             
              
              let json = {
                totalCommentary : response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.totalCommentary : null,
                totalQualification : response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.totalQualification : null,
                strFullName :  response.data.entity.personsTeachers != null ? response.data.entity.flagGroup  ?  response.data.entity.code : response.data.entity.personsTeachers.person.strFullName : null,
                photo  : response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.person.photo : null,
                location : response.data.entity.personsTeachers != null ?  response.data.entity.personsTeachers.person.countryOriginDescription : null,//se reemplazo 
                id : response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.id : null,
                personId : response.data.entity.personsTeachers != null ? response.data.entity.personsTeachers.personId : null,
                firstName :  response.data.entity.personsTeachers != null ? response.data.entity.flagGroup  ?  response.data.entity.code : response.data.entity.personsTeachers.person.firstName : null,
                lastName :  response.data.entity.personsTeachers != null ? response.data.entity.flagGroup  ?  response.data.entity.code : response.data.entity.personsTeachers.person.lastName : null,
              }
              
              this.dataTeacher = json;

              let arrayHoursTmp = response.data.entity.listGroupScheduleStudentsDetails;
              let arrayHours = convertToUserTimeCalendarEvents(arrayHoursTmp, this.$store.state.user.timeZoneName, this.$moment );
              //let arrayHours = response.data.entity.listGroupScheduleStudentsDetails;
              
              let dataList = [];
              let arrayInitWeek = []
              let arrayEnabledDate = []
          
              arrayHours.forEach((element) => {
            
                let startOfWeek = this.$moment(element.startDate).startOf('week').toDate();
                let endOfWeek = this.$moment(element.startDate).endOf('week').toDate();
       
           
                let month = (parseInt(startOfWeek.getMonth())+1) <10 ? `0${parseInt(startOfWeek.getMonth())+1}` : parseInt(startOfWeek.getMonth())+1;
                let dayDate = parseInt(startOfWeek.getDate()) < 10  ? `0${parseInt(startOfWeek.getDate())}` : parseInt(parseInt(startOfWeek.getDate()));

                let monthEnd = (parseInt(endOfWeek.getMonth())+1) <10 ? `0${parseInt(endOfWeek.getMonth())+1}` : parseInt(endOfWeek.getMonth())+1;
                let dayDateEnd = parseInt(endOfWeek.getDate())+1 < 10  ? `0${parseInt(endOfWeek.getDate())+1}` : parseInt(parseInt(endOfWeek.getDate())+1);
                 
                arrayInitWeek.push(startOfWeek.getFullYear()+'-'+month+'-'+dayDate)
              
                arrayEnabledDate.push(startOfWeek.getFullYear()+'-'+month+'-'+dayDate)
                arrayEnabledDate.push(endOfWeek.getFullYear()+'-'+monthEnd+'-'+dayDateEnd)
                
                let colorResquest = horarioObtenerColorClase(element.stateClass.value);
                let titleClass =  this.$t('horario.calendario.label-calendar-teacher', {TeacherName: element.personTeacher.person.firstName});
                  
                if(this.flagPlanTest){
                  titleClass = titleClass + "\n" + this.$t('reusables.test-class');
                }
           
               
                let nameClass =  horarioObtenerNameClaseEnEs(element.stateClass.value)
              
                this.arrayEditableSchedule.push(element.id)
                let jsonData = {
                  id: createEventId(),
                  subjectsName : this.lang == "es" ? element.subjectsName.replace("|", "\n") : element.subjectsName_EN.replace("|", "\n"),
                  title: titleClass,
                  description: "",
                  idx: element.id,
                  personTeacherId : element.personTeacherId,
                  start: element.startDate,
                  personTeacherName : element.flagGroup  ? element.code : element.personTeacher.person.lastName,
                  personTeacherNameFull : element.flagGroup  ? element.code : element.personTeacher.person.strFullName,
                  end: element.endDate,
                  color: colorResquest,
                  stateClass: element.stateClass.value,
                  stateClassName : nameClass,
                  flagPlanTest: element.flagPlanTest,
                  flagGroup: element.flagGroup,
                  editable: false,
                  linkClass: element.linkClass
                };
              
                let data = {
                  id: element.id,
                  StartDate: element.startDate,
                  EndDate: element.endDate,
                  StateClass: element.stateClass.value,
                  request:true,
                };
                dataList.push(jsonData);
                this.listCalendar.push(data);
                this.arrayCalendarInit.push(data);
              });

     
              this.optionsTime = []
              this.uniqDateEnabled = [...new Set(arrayEnabledDate)]
              
              if(this.uniqDateEnabled.length>1){
                   this.calendarOptions.validRange =  {
                      start: this.uniqDateEnabled[0],
                      end: this.uniqDateEnabled[this.uniqDateEnabled.length - 1]
                    }

               }
         
              let startOfWeekCurrent = this.$moment().startOf('week').toDate();
              console.log("startOfWeekCurrent: ",startOfWeekCurrent)
              this.uniqDate = [...new Set(arrayInitWeek)]
              console.log(" this.uniqDate: ", this.uniqDate)
              let countSelect = 0
              let countValited = 0
              for (let index = 0; index < this.uniqDate.length; index++) {
                if(this.$moment(startOfWeekCurrent).format('YYYY-MM-DD') == this.uniqDate[index]){
                  countSelect = index
                  countValited++
                }
                this.optionsTime.push({
                  value : index,
                  text : this.$t('reusables.week')  + ` ${index+1}` 
                  }  
                )
                
              }
              //console.log("countValited: ",countValited)
              //console.log("countSelect: ",countSelect)
         
              if(this.uniqDate.length>0){
                this.selectedTime = countSelect
                this.selectTimeInit = countSelect
              }
              if(countValited==0){
                this.selectedTime =  this.uniqDate.length-1
                this.selectTimeInit =  this.uniqDate.length-1
              }
              //console.log(" this.selectedTime: ", this.selectedTime)
              //console.log(" this.selectTimeInit: ", this.selectTimeInit)
              this.calendarOptions.events = dataList;
          
            }
            this.showLoadingFirst = false;
             this.showLoadingCalendar = false;

          setTimeout(() => {
            if(this.uniqDate.length>0){
              
                let calendarApi = this.$refs.fullCalendarStudent.getApi(); 
                calendarApi.gotoDate(new Date());
            }
          }, 500);
       
        })
    },
    handleDateSelect(selectInfo) {
     
      this.eventCreated = selectInfo;
      this.$bvModal.show("modal-add-event");
    },
    closeModalRemove() {
      this.showAlertModal = false;
      this.message = "";
      this.$bvModal.hide("modal-class-info");
    },	
     
    getTeacherInformationAndComments(id){
      let flag = this.lang == 'es' ? true : false;
      baseInstanceAxios
        .get(this.apiURL + `/resources/PersonsTeachers/GeTeacherInformationAndCommentList?PersonTeacherId=${id}&flagLanguage=${flag}`)
        .then(response => {
          if(response.data != null && response.data.entity != null){

            this.teacherInformation = response.data.entity;
            this.$bvModal.show('modal-commentary-teacher');
          }
        }); 
    },
     ObtenerRangoFecha(StartDate, EndDate) {
      var result = this.listCalendar.filter(function (e) {
        return (
          (!(
            new Date(StartDate).getTime() == new Date(e.StartDate).getTime()
          ) &&
            new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(StartDate).getTime() < new Date(e.EndDate).getTime() &&
            new Date(EndDate).getTime() >= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() <= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() > new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() == new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() == new Date(e.EndDate).getTime()) ||
          (new Date(StartDate).getTime() >= new Date(e.StartDate).getTime() &&
            new Date(EndDate).getTime() <= new Date(e.EndDate).getTime())
        );
      });
      return result.length;
    },
    validationForm: validationMessage(formUpdateDateMessages),
    showModalEditarHorario(){
        this.SelectBeginningDate = '';
        this.$v.$reset();
        this.$bvModal.show('modal-save-change');
    }
  },
  computed: {
     getShowSelect(){
      if(this.flagPlanTest){
        return false
      }else{
        return this.showSelectWeek
      }
 
    },
      disabledButton() {
   
        let elmts = [];
        let arrayCalendar = [];
        let arrayCalendarInit = [];
        let arraySend = this.listCalendar.filter((currentValue)=>{
          return currentValue.request 
        })
        let arraySendInit = this.arrayCalendarInit.filter((currentValue)=>{
          return currentValue.request 
        })
       
        arraySend.forEach((element) => {
          arrayCalendar.push(
            `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
          );
        });
        arraySendInit.forEach((element) => {
          arrayCalendarInit.push(
            `${new Date(element.StartDate)}-${new Date(element.EndDate)}`
          );
        });
        if (arrayCalendar.length > arrayCalendarInit.length) {
          elmts = arrayCalendar.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendarInit);
        } else {
          elmts = arrayCalendarInit.filter(function (i) {
            return this.indexOf(i) < 0;
          }, arrayCalendar);
        }
        if(arraySend.length==0){
          return true
        }else{
          return elmts.length == 0 ? true : false;
        }
        
     
      
    },
    isRepresentative : {
      get() {
        return this.$store.state.is_representative;
      }
    },
    dataGroup:{
      get() {
         return this.$store.state.group_id;
      },
      set(value) {
        this.$store.commit("mutateGroupId", value);
      } 
    },
    enableDate(){
      return this.SelectBeginningDate === ''
    }
  },

};
</script>